export default __webpack_public_path__ + "static/media/Footer_GA_License.21768e50.svg";